import { render, staticRenderFns } from "./setting-advanced-black-list.vue?vue&type=template&id=f13892e2&"
import script from "./setting-advanced-black-list.vue?vue&type=script&lang=js&"
export * from "./setting-advanced-black-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports